<template>
  <div class="home-index">
    <headers></headers>
    <div class="wrapper banner">
      <!-- <img class="img" src="./imgs/banner.png" alt="首页banner" /> -->
      <img src="./imgs/icons.png" alt="" class="img icons" />
    </div>
    <div class="wrapper applyfor">
      <img src="./imgs/btn-background.png" alt="" class="img applyfor" />
      <div class="btn-applyfor" @click="handleRouterJump">
        <div class="btn">申请调解</div>
      </div>
    </div>
    <div class="wrapper bottom">
      <img src="./imgs/logo.png" alt="logo" class="img logo" />
      <img src="./imgs/analyse.png" alt="" class="img analyse" />
      <img src="./imgs/description.png" alt="" class="img description" />
      <img src="./imgs/ccpit.png" alt="" class="img ccpit" />
    </div>
  </div>
</template>

<script>
import { getStore } from "@/utils/utils";
import headers from "@/components/header";
export default {
  name: "indexpage",
  data() {
    return {};
  },
  components: {
    headers,
  },
  watch: {},
  methods: {
    handleRouterJump() {
      const loginRoleInfo = JSON.parse(getStore("userInfo"));
      if (loginRoleInfo) {
        this.$router.push({ name: "cmmonUserApplyfor" });
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  mounted() {},
  updated() {},
};
</script>

<style scoped lang="scss">
$padding-left:1em;
$padding-right:1em;
.home-index {
  background-color: #fff;
  .wrapper.banner {
    background: url("./imgs/banner.png") 100%;
    background-position: bottom;
    background-size: cover;
    background-repeat: no-repeat;
    background-clip: border-box;
    min-height: 340px;
    position: relative;
    display: flex;
    flex-direction: columns;
    justify-content: center;
    .icons {
      position: absolute;
      bottom: 0;
      // height: 86px;
    }
  }
  .wrapper.applyfor {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    .img {
      // height: 124px;
    }
    .btn-applyfor {
      position: absolute;
      color: #f9f9f9;
      background: linear-gradient(90deg, #30afff, #0069ef);
      box-shadow: 0px 24px 20px 0px rgba(102, 174, 228, 0.3);
      border-radius: 999rem;
      // line-height: 19px;
      border: rgba(102, 174, 228, 0.3);
      width: 85%;
      height:4em;
      bottom: -1em;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .btn {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }

  .logo {
    // height: 28px;
  }
  .analyse {
    // height: 58px;
  }
  .description {
    // height:210px;
  }
  .bottom {
    background: url("./imgs/earth.png") no-repeat 30% 0;
    width: 100%;
    background-size: cover;
    margin-top: 1rem;
  }
  .img {
    padding: 0 $padding-left;
    // width: 346px;
    width: 94%;
    margin: 10px 0;
  }
}
</style>
